<template>
  <div data-test="partnership-referral">
    <static-header @close="leaveFlow" />

    <section class="flow__body container row">
      <partnership-referral-receipt
        v-if="showReceipt"
        data-test="partnership-referral-receipt"
        :view-model="viewModel"
        :accept-button-label="viewModel.acceptButtonLabel"
      />
      <partnership-referral-flow
        v-else
        data-test="partnership-referral-flow"
        :view-model="viewModel"
        :receipt-button="viewModel.receiptButton"
        :datasource="datasource"
        @order-call="changeShowReceipt"
      />
    </section>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import PartnershipReferralFlow from '../components/PartnershipReferralFlow.vue';
import PartnershipReferralReceipt from '../components/PartnershipReferralReceipt.vue';
import {
  PartnershipReferralData,
  PartnershipReferralViewModel
} from '../types/PartnershipReferral';
import StaticHeader from '@/components/UI/StaticHeader.vue';
import RequestService from '@/common/requestService';
import Utility from '@/common/UtilityFunctions.js';

export default defineComponent({
  name: 'PartnershipReferral',
  components: {
    StaticHeader,
    PartnershipReferralFlow,
    PartnershipReferralReceipt
  },
  props: {
    datasource: {
      type: String,
      default() {
        return '';
      }
    }
  },
  data(): PartnershipReferralData {
    return {
      showReceipt: false,
      viewModel: {
        title: '',
        pensionQuestionLabel: '',
        contactInfoLabel: '',
        nameLabel: '',
        nameValidationError: '',
        phoneNumberLabel: '',
        consentLabel: '',
        consentValidationError: '',
        acceptButtonLabel: '',
        pensionQuestionInfoText: '',
        pensionQuestionOnYesInfoText: '',
        receiptHeadline: '',
        receiptBody: '',
        receiptButton: {
          url: '',
          text: '',
          cssClass: ''
        }
      }
    };
  },
  mounted() {
    this.getViewModel();
  },
  methods: {
    changeShowReceipt(): void {
      this.showReceipt = true;
    },
    leaveFlow(): void {
      location.href = '/';
    },
    async getViewModel(): Promise<void> {
      await RequestService.get<PartnershipReferralViewModel>(
        `${Utility.constants().API.partnership_referral_get}/${this.datasource}`
      )
        .then((response) => {
          const data = response.data;
          this.viewModel = data;
        })
        .catch((err) => Utility.logError(err, this));
    }
  }
});
</script>
../../../../../common/requestService
